import { theme as sodimacTheme } from './sodimac';
import { theme as falabellaTheme } from './falabella';
import { IThemes } from '../models/IThemes';
import { IThemeList } from '../models/IThemeList';

export const defaultTheme = 'sodimac';

export const themes: IThemes = [
  {
    ...sodimacTheme,
    id: 'sodimac',
    name: 'Sodimac',
  },
  {
    ...falabellaTheme,
    id: 'falabella',
    name: 'Falabella',
  },
];

export const themesList: IThemeList = themes.map((item: any) => item.id);
